import purify, { type Config } from 'dompurify'

export const safeHtml = (html: string): string => {
  return purify.sanitize(html)
}

const untrustedConfig: Config = {
  USE_PROFILES: { html: true },
  FORBID_TAGS: [
    'style',
    'form',
    'input',
    'textarea',
    'select',
    'option',
    'optgroup',
    'button',
    'fieldset',
    'legend',
    'label',
    'dialog',
  ],
  FORBID_ATTR: ['style', 'id', 'name'],
  // A forbidden element disappears with its text, so a form does not leave stray labels behind.
  KEEP_CONTENT: false,
}

export const safeUntrustedHtml = (html: string): string => {
  return purify.sanitize(html, untrustedConfig)
}
